import { useSelector } from 'react-redux';
import { StatusType } from 'commons/types';
import { getAuthSyncStatus } from 'domains/Auth/authSlice/authSelectors';

function useGetSyncStatus(): StatusType {
  return useSelector(getAuthSyncStatus);
}

export default useGetSyncStatus;
